import {
    GET_NOTIFICATIONS,
    GET_NOTIFICATIONS_SUCCESS,
    GET_NOTIFICATIONS_FAILURE,
    GET_NOTIFICATIONS_NUMBER,
    GET_NOTIFICATIONS_NUMBER_SUCCESS,
    GET_NOTIFICATIONS_NUMBER_FAILURE
} from './constants';

export const getNotifications = () => ({
    type: GET_NOTIFICATIONS,
    payload: {},
});

export const getNotificationsSuccess = (notifications) => ({
    type: GET_NOTIFICATIONS_SUCCESS,
    payload: notifications
});

export const getNotificationsFailure = (error) => ({
    type: GET_NOTIFICATIONS_FAILURE,
    payload: { message: error },
});

export const getNotificationsNumber = () => ({
    type: GET_NOTIFICATIONS_NUMBER,
    payload: {},
});

export const getNotificationsNumberSuccess = (notifications_count) => ({
    type: GET_NOTIFICATIONS_NUMBER_SUCCESS,
    payload: { notifications_count }
});

export const getNotificationsNumberFailure = (error) => ({
    type: GET_NOTIFICATIONS_NUMBER_FAILURE,
    payload: { message: error }
});